// extracted by mini-css-extract-plugin
export default {"container":"MA9aR6"};